import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { listBlogs } from "../../server/apihelper"; // ✅ use blog API here
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export const Blog = () => {
  const [blogList, setBlogList] = useState([]);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const query = "page=1&items_per_page=10";
    listBlogs(query).then((res) => {
      setBlogList(res.data);
    });
    console.log("blogList", blogList);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    return { day, month };
  };

  return (
    <>
      {/* SEO Tags */}
      <div>
        <Helmet>
          <title>
            Architecture Articles and Blogs | McGAN’S Ooty School of Architecture
          </title>
          <meta
            name="description"
            content="Discover insightful architecture blogs, design trends, and creative ideas from McGAN’S Ooty School of Architecture. Read inspiring articles written by experts and students alike."
          />
          <meta
            name="keywords"
            content="Architecture Blogs, Architecture Articles, McGAN’S Ooty Blog, Architectural Design Trends, Student Blogs, Architecture Insights, McGAN’S Ooty School of Architecture"
          />
          <meta
            property="og:title"
            content="Architecture Blogs and Insights | McGAN’S Ooty"
          />
          <meta
            property="og:description"
            content="Explore creative architecture ideas and blogs from McGAN’S Ooty School of Architecture."
          />
          <meta property="og:image" content="https://mcgansarch.com/" />
          <link rel="canonical" href="https://mcgansarch.com/blogs" />
        </Helmet>
        <h1 style={{ display: "none" }}>
          Architecture Blogs and Articles | McGAN’S Ooty School of Architecture
        </h1>
      </div>

      <div>
        {/* Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h3 className="BannerHeader">Blogs</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">Blogs</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Blog List Section */}
        <div className="campus-life-area pt-100 pb-70">
          <div className="container">
            <div className="row justify-content-center">
              <h5>LATEST BLOGS AT McGAN’S</h5>
              {blogList.map((item, index) => {
                const { day, month } = formatDate(item.date);
                return (
                  <div className="col-lg-4 col-md-6" key={index}>
                    <div className="single-events-card style-4">
                      <div className="events-image">
                        <Link
                          to={`/blog-details/${item?.primaryId}`}
                          className="read-more-btn"
                        >
                          <img
                            src={item.image}
                            width={416}
                            height={251}
                            title="McGAN’S Ooty Blog"
                            alt="McGAN’S Ooty Blog"
                          />
                        </Link>
                        <div className="date">
                          <span>{day}</span>
                          <p>{month}</p>
                        </div>
                      </div>
                      <div className="events-content">
                        <div className="admin">
                          <p>
                            <a>
                              <i className="ri-user-line"></i>
                              {item.author || "Admin"}
                            </a>
                          </p>
                        </div>
                        <Link
                          to={`/blog-details/${item?.primaryId}`}
                          className="read-more-btn"
                        >
                          <h3>{item.title}</h3>
                        </Link>
                        <Link
                          to={`/blog-details/${item?.primaryId}`}
                          className="read-more-btn"
                        >
                          Read More<i className="flaticon-next"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
